// extracted by mini-css-extract-plugin
module.exports = {"tile":"TileBase_tile_32yjH","overlay":"TileBase_overlay_2s1bD","image":"TileBase_image_1Jxmp","content":"TileBase_content_26VUJ"};